import classNames from "../../../utils/classNames";
import { Label, RadioGroup } from "@headlessui/react";
import { useTranslation } from "react-i18next";


export default function Tabs({ viewType, viewTypes, setViewType }: { viewType: number, viewTypes: { value: number, label: string }[], setViewType: (value: number) => void }) {
  const { t } = useTranslation("common");

  //Example
  // const [viewType, setViewType] = useState(0);
  // const viewTypes = [
  //   { value: 0, label: "Pages" },
  //   { value: 1, label: "Policies" },
  // ];


  const gridCols = `grid grid-cols-1 lg:grid-cols-${viewTypes.length} gap-3`;

  return (
    <RadioGroup value={viewType} onChange={setViewType} className="my-4">
      <Label className="sr-only">
        {t("Choose which view to display")}
      </Label>
      <div className={gridCols}>
        {viewTypes.map((type) => (
          <RadioGroup.Option
            key={`${type.value}`}
            value={type.value}
            className={({ active, checked }) =>
              classNames(
                active ? "ring-2 ring-offset-2 ring-primary" : "",
                checked
                  ? "bg-primary border-transparent text-white hover:bg-primary"
                  : "bg-white border-gray-200 text-gray-900 hover:bg-gray-50",
                "cursor-pointer focus:outline-none border rounded-md py-1.5 px-3 flex items-center justify-center text-sm font-medium uppercase sm:flex-1"
              )
            }
          >
            <Label as="span">{type.label}</Label>
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>
  )

}